// Перше за день відкриття сайту під час ефіру одразу веде на /live.
//
// Ефір іде кілька годин на день, і глядач, який зайшов у цей час, майже
// напевно прийшов саме за ним — але з каталогу бачив тільки картку серед
// аніме й міг її не помітити взагалі. Тому першу за добу сесію перекидаємо
// на ефір самі.
//
// Рівно ОДИН раз на добу. Дату записуємо лише тоді, коли перекидання
// справді сталося: візит повз вимкнений ефір нічого не витрачає, і людина,
// яка зайшла вранці до стріму, ввечері все одно потрапить на ефір.
// Повернення назад працює звичайною кнопкою браузера — сторінку, з якої
// глядача забрали, лишаємо в історії.

const REDIRECT_KEY = 'live_auto_redirect'

// Ключ доби — місцевий, а не UTC: «раз на день» глядач рахує за своїм
// годинником, і в нас із ним різниця може бути в кілька годин
const todayKey = () => {
  const now = new Date()
  const pad = (n) => String(n).padStart(2, '0')
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
}

const redirectedToday = () => {
  try {
    return localStorage.getItem(REDIRECT_KEY) === todayKey()
  } catch (e) {
    // Приватний режим чи заборонене сховище: запам'ятати добу нічим, а
    // перекидати щоразу — гірше, ніж не перекидати зовсім
    return true
  }
}

const rememberRedirect = () => {
  try {
    localStorage.setItem(REDIRECT_KEY, todayKey())
  } catch (e) {}
}

// Сторінки, з яких не забираємо. /live — очевидно; /live-chat — джерело
// чату для OBS, там взагалі немає глядача, якому можна щось підказати, а
// перекидання перетворило б оверлей на сторінку ефіру просто в ефірі;
// решта — кроки входу: перекидання посеред OAuth-колбека обірвало б
// авторизацію
const KEEP = [
  /^\/live(\/|$)/,
  /^\/live-chat(\/|$)/,
  /^\/auth(\/|$)/,
  /^\/login(\/|$)/
]

export const useLiveAutoRedirect = () => {
  if (!import.meta.client) return

  const client = useStrapiClient()
  const route = useRoute()

  onMounted(async () => {
    if (KEEP.some((re) => re.test(route.path))) return
    if (redirectedToday()) return

    let access = null

    try {
      access = await client('/live-setting/access')
    } catch (e) {
      // Ефір — не той функціонал, заради якого варто щось показувати
      // людині, яка прийшла читати каталог
      return
    }

    // Ефір іде = рівно те, за чим каталог малює картку стріму (див.
    // pages/index.vue). Плюс allowed: закритий ефір показав би замість
    // плеєра екран входу, а тягнути туди силоміць — це вже не підказка
    const live = !access?.offline && !!access?.showInCatalog && !!access?.allowed
    if (!live) return

    // Поки ходив запит, глядач міг сам піти кудись, звідки не забираємо
    // (route реактивний — тут це вже поточний шлях, а не той, що на монтуванні)
    if (KEEP.some((re) => re.test(route.path))) return

    rememberRedirect()
    // Повне перезавантаження, а не navigateTo: /live — окрема сторінка зі
    // своїм layout і плеєром, і клієнтський перехід приносив її туди
    // напівживою (на телефоні від плеєра лишалась сама кнопка play).
    // На ефір ведуть саме так усі шляхи — посилання в навбарі, картка в
    // каталозі (live/Card.vue) і повернення після входу (auth/callback)
    window.location.assign('/live')
  })
}
